import React from "react";
import isEmpty from "lodash/isEmpty";
import { Controller, ControllerRenderProps } from "react-hook-form";
import { EuiFieldPassword, EuiFormRow } from "@elastic/eui";

export interface IPasswordForm {
  control: any;
  name: string;
  require?: boolean | false;
  label: string;
  errors: any;
  isDisable?: boolean | false;
  initValue?: string;
}

export function PasswordForm(props: IPasswordForm) {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={{ required: props.require }}
      render={({ field }) => {
        const {ref, ...otherProps} = field;

        return (
          <EuiFormRow
            fullWidth
            isDisabled={props.isDisable}
            label={props.label}
            isInvalid={!isEmpty(props.errors[props.name])}
            error={props?.errors[props.name]?.message}
          >
            <EuiFieldPassword
              fullWidth
              {...otherProps}
              type={'dual'}
              value={props.initValue}
            />
          </EuiFormRow>
        )
      }}
    />
  );
}
